/**
 * Threads of comments in publications (FB/IG/TT), different from Messenger/DM.
 * @type {ReadonlySet<string>}
 */
const COMMENT_THREAD_PLATFORMS = new Set(['facebook_comments', 'instagram_comments', 'tik_tok_comments']);

export default COMMENT_THREAD_PLATFORMS;
